import { type Nullable } from '@direct-frontend/stdlib';

export const getNearestScrollableParent = (element: Nullable<HTMLElement>): HTMLElement => {
    let parent = element;

    while (parent) {
        const style = window.getComputedStyle(parent);

        if (
            style.overflow !== 'visible' &&
            style.overflow !== 'hidden' &&
            (style.overflowY === 'scroll' ||
                style.overflowY === 'auto' ||
                style.overflowX === 'scroll' ||
                style.overflowX === 'auto')
        ) {
            return parent;
        }

        parent = parent.parentElement;
    }

    return document.documentElement || document.body;
};
